<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :stripe="false"
      :selection="hasBtn && selection"
      right-toolbar-hide
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('OrdinaryOrderMix.GoodsInfoTab.Receiving')" prop="receiveStatus">
            <BjSelectLov
              v-model="queryParams.receiveStatus"
              constant-key="ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST"
            />
          </el-form-item>
        </el-col>
        <template v-if="businessType == ORDER_BUSINESS_TYPES.COMMON">
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.GoodsInfoTab.Shipment')" prop="deliveryStatus">
              <BjSelectLov
                v-model="queryParams.deliveryStatus"
                constant-key="ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <!-- #ifndef OPEN-SOURCE -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.GoodsInfoTab.occupied')" prop="preemptionStatus">
              <BjSelectLov
                v-model="queryParams.preemptionStatus"
                constant-key="ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.GoodsInfoTab.Sourcing')" prop="sourceStatus">
              <BjSelectLov
                v-model="queryParams.sourceStatus"
                constant-key="ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <!-- #endif -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.GoodsInfoTab.status')" prop="suspendStatus">
              <BjSelectLov
                v-model="queryParams.suspendStatus"
                constant-key="ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <!-- #ifndef OPEN-SOURCE -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.GoodsInfoTab.Write')" prop="syncPreempStatus">
              <BjSelectLov
                v-model="queryParams.syncPreempStatus"
                constant-key="ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <!-- #endif -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.GoodsInfoTab.update')" prop="syncDeliveryStatus">
              <BjSelectLov
                v-model="queryParams.syncDeliveryStatus"
                constant-key="ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST"
              />
            </el-form-item> </el-col
        ></template>
      </template>

      <template v-slot:tableColumn>
        <el-table-column prop="tags" :label="$t('OrdinaryOrderMix.GoodsInfoTab.Label')" show-overflow-tooltip align="center" width="97">
          <template slot-scope="scope">
            <BjTagList :tag-code-string="scope.row.tags" />
          </template>
        </el-table-column>
        <!-- <el-table-column prop="spuName" :label="$t('goodsPage.spuName')" show-overflow-tooltip align="center"  width="160" />
        <el-table-column prop="spuCode" :label="$t('goodsPage.spuCode')" align="center"  width="160"> </el-table-column> -->
        <el-table-column prop="skuCode" :label="$t('OrdinaryOrderMix.GoodsInfoTab.SKU')" align="center" min-width="107"> </el-table-column>
        <el-table-column prop="giftFlag" :label="$t('OrdinaryOrderMix.GoodsInfoTab.Giveaway')" align="center" min-width="125">
          <template slot-scope="scope">
            <el-tag :type="scope.row.giftFlag ? 'success' : 'info'">{{
              $t(STATUS_YES_NUM.bjGet(!!scope.row.giftFlag))
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" :label="$t('OrdinaryOrderMix.GoodsInfoTab.Quantity')" align="center" min-width="81"> </el-table-column>
        <el-table-column prop="thirdSaleAmount" :label="$t('OrdinaryOrderMix.GoodsInfoTab.platform')" align="center" min-width="151"
          ><template slot-scope="scope">
            {{ $number2money(scope.row.thirdSaleAmount) }}
          </template></el-table-column
        >
        <!-- <el-table-column prop="outBalancePrice" :label="$t('OrdinaryOrderMix.GoodsInfoTab.total')" align="center" width="162"
          ><template slot-scope="scope">
            {{ $number2money(scope.row.outBalancePrice) }}
          </template></el-table-column
        > -->
        <el-table-column prop="innerSalePrice" :label="$t('OrdinaryOrderMix.GoodsInfoTab.sales')" align="center" min-width="105"
          ><template slot-scope="scope">
            {{ $number2money(scope.row.innerSalePrice) }}
          </template></el-table-column
        >

        <!-- <el-table-column prop="innerBalancePrice" :label="$t('OrdinaryOrderMix.GoodsInfoTab.average')" align="center" width="122"
          ><template slot-scope="scope">
            {{ $number2money(scope.row.innerBalancePrice) }}
          </template></el-table-column
        >
        <el-table-column prop="costAmount" :label="$t('OrdinaryOrderMix.GoodsInfoTab.Cost')" align="center" width="113"
          ><template slot-scope="scope">
            {{ $number2money(scope.row.costAmount) }}
          </template></el-table-column
        >
        <el-table-column prop="totalCostAmount" :label="$t('OrdinaryOrderMix.GoodsInfoTab.Totalf')" align="center" width="80"
          ><template slot-scope="scope">
            {{ $number2money(scope.row.totalCostAmount) }}
        </template>
        </el-table-column> -->
        <el-table-column prop="transPrice" :label="$t('OrdinaryOrderMix.GoodsInfoTab.Freight')" align="center" min-width="74"
          ><template slot-scope="scope">
            {{ $number2money(scope.row.transPrice) }}
          </template></el-table-column
        >
        <template v-if="businessType == ORDER_BUSINESS_TYPES.COMMON">
          <el-table-column prop="deliveryStatus" :label="$t('OrdinaryOrderMix.GoodsInfoTab.Shipment')" align="center" min-width="119"
            ><template slot-scope="scope">
              {{ $t(ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST.bjGet(scope.row.deliveryStatus)) }}
            </template></el-table-column
          ></template
        >
        <el-table-column prop="receivingStatus" :label="$t('OrdinaryOrderMix.GoodsInfoTab.Receiving')" align="center" min-width="126"
          ><template slot-scope="scope">
            {{ $t(ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST.bjGet(scope.row.receivingStatus)) }}
          </template></el-table-column
        >

        <template v-if="businessType == ORDER_BUSINESS_TYPES.COMMON">
          <!-- #ifndef OPEN-SOURCE -->
          <el-table-column prop="preemptionStatus" :label="$t('OrdinaryOrderMix.GoodsInfoTab.occupied')" align="center" width="143"
            ><template slot-scope="scope">
              {{ $t(ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST.bjGet(scope.row.preemptionStatus)) }}
            </template></el-table-column
          >
          <el-table-column prop="sourceStatus" :label="$t('OrdinaryOrderMix.GoodsInfoTab.Sourcing')" align="center" width="131"
            ><template slot-scope="scope">
              {{ $t(ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST.bjGet(scope.row.sourceStatus)) }}
            </template></el-table-column
          >
          <!-- #endif -->
          <el-table-column prop="suspendStatus" :label="$t('OrdinaryOrderMix.GoodsInfoTab.Pending')" align="center" width="198"
            ><template slot-scope="scope">
              {{ $t(ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST.bjGet(scope.row.suspendStatus)) }}
            </template></el-table-column
          >
          <!-- #ifndef OPEN-SOURCE -->
          <el-table-column prop="syncPreempStatus" :label="$t('OrdinaryOrderMix.GoodsInfoTab.Write')" align="center" width="141"
            ><template slot-scope="scope">
              {{ $t(ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST.bjGet(scope.row.syncPreempStatus)) }}
            </template></el-table-column
          >
          <!-- #endif -->
          <el-table-column prop="syncDeliveryStatus" :label="$t('OrdinaryOrderMix.GoodsInfoTab.update')" align="center" width="170"
            ><template slot-scope="scope">
              {{ $t(ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST.bjGet(scope.row.syncDeliveryStatus)) }}
            </template></el-table-column
          ></template
        >
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import {
  STATUS_YES_NUM,
  ORDER_INTERNAL_ORDER_STATUS_LIST,
  // #ifndef OPEN-SOURCE
  ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
  ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
  ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST,
  // #endif
  ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST,
  ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST,
  ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST,
  ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
  ORDER_BUSINESS_TYPES,
} from '@/utils/constants';

export default {
  name: 'BusinessOrderInternalViewSkuLineList',
  components: {},
  mixins: [pageMiXin],
  props: {
    orderId: {
      type: String,
      default: null,
    },
    hasBtn: {
      type: Boolean,
      default: true,
    },
    businessType: {
      type: String,
      default: ORDER_BUSINESS_TYPES.COMMON,
    },
  },

  data() {
    return {
      sortTableByOptionName: true,
      STATUS_YES_NUM,
      ORDER_INTERNAL_ORDER_STATUS_LIST,
      // #ifndef OPEN-SOURCE
      ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
      ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST,
      ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
      // #endif
      ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST,
      ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST,
      ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST,
      ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
      ORDER_BUSINESS_TYPES,
      queryApi: orderApi.getInternalSkuLineListByOrder,
      // 查询参数
      queryParams: {
        deliveryStatus: null,
        // isOutStock: null,
        refundFlag: null,
        orderId: null,
        preemptionStatus: null,
        receiveStatus: null,
        sourceStatus: null,
        suspendStatus: null,
        syncDeliveryStatus: null,
        syncPreempStatus: null,
      },
      labelsVersion: 11,
      tableSortableDisabled: true,

      selectedRows: null,
    };
  },
  watch: {},
  created() {
    this.queryParams.orderId = this.orderId;
  },
  methods: {},
};
</script>
